export const ui = {
    password_change_complete: {
        th: 'เราได้เปลี่ยนรหัสผ่านของคุณเรียบร้อยแล้ว',
        en: 'We have successfully changed your password.'
    },
    password_reset_verify_hint: {
        th: 'โปรดกรอกรหัสผ่านใหม่ที่ต้องการ',
        en: 'Please enter the desired new password.',
    },
    notReady: {
        th: 'การโหลดหน้าเว็บยังไม่เสร็จสิ้น',
        en: 'Page not ready yet!',
    },
    noRecaptcha: {
        th: 'โปรดแสดงตัวตนว่าท่านไม่ใช่บ๊อต',
        en: 'Please prove yourself that you are not a bot.',
    },
    previewFile: {
        th: 'ภาพตัวอย่าง',
        en: 'Preview'
    },
    selectFile: {
        th: 'คลิกเพื่อเลือกไฟล์',
        en: 'Click to Select file'
    },
    clearFile: {
        th: 'นำออก',
        en: 'Clear'
    },
    developer: {
        th: 'ผู้พัฒนา',
        en: 'Developer'
    },
    home: {
        th: 'หน้าแรก',
        en: 'Home',
    },
    register: {
        th: 'สมัครสมาชิก',
        en: 'Register'
    },
    register_hint: {
        th: 'ยังไม่มีบัญชีผู้ใช้งานใช่หรือไม่',
        en: 'New on our platform'
    },
    register_form_hint: {
        th: 'โปรดกรอกข้อมูลเพื่อใช้ในการสมัครสมาชิกให้ครบถ้วน',
        en: 'Please complete the information for applying for membership.'
    },
    register_submit: {
        th: 'สมัครสมาชิก',
        en: 'Submit'
    },
    register_sent: {
        th: 'เราได้ทำการส่งอีเมล์ไปหาคุณเพื่อยืนยันการสมัครสมาชิก โปรดทำการตรวจสอบอีเมล์เพื่อดำเนินการต่อ',
        en: 'We have sent you an email to confirm your subscription. Please check your email to proceed.'
    },
    external_register: {
        th: 'สมัครสมาชิกโดยใช้บัญชีอื่น',
        en: 'Register using another account'
    },
    login: {
        th: 'เข้าสู่ระบบ',
        en: 'Sign in'
    },
    logoff: {
        th: 'ออกจากระบบ',
        en: 'Sign out'
    },
    settings: {
        th: 'การตั้งค่า',
        en: 'Settings'
    },
    noData: {
        th: 'ไม่มีข้อมูล',
        en: 'No data'
    },
    loading: {
        th: 'กำลังทำงาน',
        en: 'Loading'
    },
    email: {
        th: 'อีเมล์',
        en: 'Email'
    },
    password: {
        th: 'รหัสผ่าน',
        en: 'Password'
    },
    confirmPassword: {
        th: 'ยืนยันรหัสผ่าน',
        en: 'Confirm password'
    },
    password_recovery: {
        th: 'ลืมรหัสผ่าน',
        en: 'Recovery password'
    },
    passwordNotMatched: {
        th: 'รหัสผ่านและการยืนยันรหัสผ่านไม่ตรงกัน',
        en: 'Password and password confirmation do not match.'
    },
    external_login: {
        th: 'เข้าสู่ระบบด้วยบัญชีอื่น',
        en: 'Login with existing account'
    },
    profile: {
        th: 'โปรไฟล์',
        en: 'Profile'
    },
    displayName: {
        th: 'ชื่อที่แสดง',
        en: 'Display name'
    },
    language: {
        th: 'ภาษาที่แสดง',
        en: 'Language'
    },
    theme: {
        th: 'ธีม',
        en: 'Theme'
    },
    submit: {
        th: 'บันทึก',
        en: 'Submit'
    },
    changePicture: {
        th: 'เปลี่ยนรูปภาพ',
        en: 'Change picture'
    },
    add: {
        th: 'เพิ่ม',
        en: 'Add'
    },
    refresh: {
        th: 'รีเฟรซ',
        en: 'Refresh'
    },
    search: {
        th: 'ค้นหา',
        en: 'Search'
    },
    searchByKeyword:{
        th: 'กรอกคำค้นหา',
        en: 'Search by keyword'
    },
    edit: {
        th: 'แก้ไข',
        en: 'Edit'
    },
    remove: {
        th: 'ลบทิ้ง',
        en: 'Delete'
    },
    cancel: {
        th: 'ยกเลิก',
        en: 'Cancel'
    },
    confirmDelete: {
        th: 'คุณต้องการลบข้อมูลที่เลือกใช่หรือไม่',
        en: 'Do you want to delete selected item'
    },
    formInvalid: {
        th: 'โปรดกรอกข้อมูลบังคับให้ครบถ้วน',
        en: 'Please input required data'
    },
    requireMsg: {
        th: 'โปรดกรอกข้อมูล',
        en: 'Requiredใ'
    },
    lengthMsg: {
        th: 'ข้อความสั้นเกินไป',
        en: 'Need more charactorsใ'
    },
    invalidNumMsg: {
        th: 'ค่าน้อยกว่าหรือมากกว่าที่กำหนดไว้',
        en: 'The value is less than or greater than the specified value.'
    },
    error: {
        th: 'เกิดข้อผิดพลาด',
        en: 'Error occuredใ'
    },
    toDay: {
        th: 'วันนี้',
        en: 'Today'
    },
    month: {
        th: 'เดือน',
        en: 'Month'
    },
    months: {
        th: ['ม.ค', 'ก.พ', 'มี.ค', 'เม.ย', 'พ.ค', 'มิ.ย', 'ก.ค', 'ส.ค', 'ก.ย', 'ต.ค', 'พ.ย', 'ธ.ค'],
        en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    week: {
        th: 'สัปดาห์',
        en: 'Week'
    },
    day: {
        th: 'วัน',
        en: 'Day'
    },
    year: {
        th: 'ปี',
        en: 'Year'
    },
    noMessage: {
        th: 'ไม่มีข้อความใหม่',
        en: 'No message'
    },
    userNotExit: {
        th: 'ไม่พบบัญชีผู้ใช้งานของคุณ',
        en: 'Can not find an account'
    },
    notification: {
        th: 'ข้อความแจ้งเตือน',
        en: 'Notification messages'
    },
    maskRead: {
        th: 'อ่านแล้ว',
        en: 'Mask as read'
    },
    confirmLogoff: {
        th: 'คุณต้องการออกจากระบบใช่หรือไม่',
        en: 'Do you want to sign out'
    },
    close: {
        th: 'ปิด',
        en: 'Close'
    },
    select: {
        th: 'เลือก',
        en: 'Select'
    },
    signout_complete: {
        th: 'ดำเนินการออกจากระบบเรียบร้อยแล้ว',
        en: 'Sign out complete'
    },
    password_reset_hint: {
        th: 'โปรดกรอกอีเมล์ที่ใช้ในการสมัครสมาชิกของคุณเพื่อรับลิงค์สำหรับเปลี่ยนรหัสผ่าน',
        en: 'Please enter your registered email address to receive a link to change your password.'
    },
    password_reset_submit: {
        th: 'ส่งอีเมล์',
        en: 'Send'
    },
    password_reset_sent: {
        th: 'เราได้ทำการส่งอีเมล์ไปหาคุณพร้อมลิงค์สำหรับเปลี่ยนรหัสผ่าน โปรดทำการตรวจสอบอีเมล์เพื่อดำเนินการต่อ',
        en: 'We have sent you an email with a link to change your password. Please check your email to proceed.'
    },
    ok: {
        th: 'ยืนยัน',
        en: 'Ok'
    },
    err_1: {
        th: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ',
        en: 'Sign in error'
    },
    err_2: {
        th: 'ไม่พบบัญชีผู้ใช้งาน',
        en: 'User not found'
    },
    err_3: {
        th: 'เกิดข้อผิดพลาดจากผู้ให้บริการบัญชีของคุณ',
        en: 'User provider service error'
    },
    err_4: {
        th: 'ข้อมูลจากผู้ให้บริการบัญชีของคุณไม่ถูกต้อง',
        en: 'Invalid user provider service data'
    },
    err_20: {
        th: 'ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง',
        en: 'Incorrect username or password'
    },
    err_21: {
        th: 'บัญชีผู้ใช้งานถูกปิดชั่วคราว',
        en: 'User account locked'
    },
    err_22: {
        th: 'บัญชีผู้ใช้งานอยู่ระหว่างรอการยืนยันอนุมัติ',
        en: 'User account wating for approval'
    },
}